window.components.calculator = {
    selector: 'section[calculator]',

    init: function () {
        this.events();
    },

    events: function () {
        $(this.selector).find('[open-calculator]').on('click', this.onClickOpenCalculator);
    },

    onClickOpenCalculator: function (e) {
        e.preventDefault();
    },
};
